import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Eyebrow, H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { planningQuestions } from '../../data/content';
export function QuestionsSection() {
  return <Section tone="white" narrow data-id="element-259" data-mp="ipoheycs6n98">
      <Eyebrow data-id="element-260" data-mp="nqm1xhl9jtdw">From a complex implant case…</Eyebrow>
      <H2 className="mt-3" data-id="element-261" data-mp="nq2relxy079w">…To a Clinical Roadmap You Can Actually Follow.</H2>
      <p className="mt-5 text-lg leading-relaxed text-ink/80" data-id="element-262" data-mp="3n7ah6icnexf3">
        You already know that dental implant treatment involves much more than placing an implant. Before treatment begins, several important questions need to be addressed.
      </p>

      <ul className="mt-8 divide-y divide-ink/10 rounded-2xl bg-paper px-5 ring-1 ring-ink/10" data-id="element-263" data-mp="4rzwjqiprg46">
        {planningQuestions.map(q => <li key={q} className="flex items-start gap-3 py-4 text-[17px] font-semibold leading-snug" data-id="element-264" data-mp="33gyr723pnu0b">
            <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent-strong" aria-hidden="true" data-id="element-265" data-mp="38g1m3tpz8juk" />
            {q}
          </li>)}
      </ul>

      <div className="mt-8 space-y-4 text-lg leading-relaxed text-ink/80" data-id="element-266" data-mp="164rzfgk4cqn9">
        <p data-id="element-267" data-mp="165l6kimzpi5x">When these decisions are considered separately, the planning process can become difficult to organize.</p>
        <p className="font-bold text-ink" data-id="element-268" data-mp="11bqhezom8azg">
          That’s why Dental Implant Clinical Roadmap™ brings the essential stages together into one structured educational framework.
        </p>
        <p data-id="element-269" data-mp="rdsucfihsk8f">
          Instead of treating patient assessment, imaging, surgical planning, restoration, and follow-up as disconnected subjects, you’ll study how they relate to one another.
        </p>
      </div>

      <div className="mt-10" data-id="element-270" data-mp="ih1yo47ur7ed">
        <CtaButton label="I want my clinical roadmap" note="One-Time Payment of $27 USD · Lifetime Access" data-id="element-271" data-mp="dgw4ohe418t4" />
      </div>
    </Section>;
}